import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=99836922&"
import script from "./OrderForm.vue?vue&type=script&lang=ts&"
export * from "./OrderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports